/// <reference path="../Expenses/ExpensesGrid.ts" />

namespace Nobox.CRM {

    import fld = ExpensesRow.Fields;

    @Serenity.Decorators.registerClass()
    export class DealsExpensesGrid extends ExpensesGrid {
        protected getDialogType() { return ExpensesDialog; }

        constructor(container: JQuery) {
            super(container);
        }

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);
            Serenity.SubDialogHelper.cascade(dialog, this.element.closest('.ui-dialog'));
        }

        protected addButtonClick() {
            this.editItem({ DealIds: this.dealId });
        }


        protected getPersistanceStorage(): Serenity.SettingStorage {
            return window.localStorage;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.dealId;
        }

        private _GroupID: string;

        get dealId() {
            return this._GroupID;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            //request.ColumnSelection = 1;
            request.EqualityFilter.DealIds = this.dealId;
            //request.EqualityFilter.GroupIds = this.dealId;
        }
        set dealId(value: string) {
            if (this._GroupID !== value) {
                this._GroupID = value;
                this.refresh();
            }
        }
    }
}